import React from 'react';
import { EmptyAddress } from 'emergency_data/src/components/Location/styles/locationAddress.styles';

export const NoAddress = () => {
  return <EmptyAddress noAddress>Address Not Found</EmptyAddress>;
};
